const uploadFileOptions = {
  name: 'pdf',
  multiple: false,
  accept: '.pdf',
};
export default uploadFileOptions;
